import { Project, RawProject } from "@/types/project";

export const mapRawToProject = (raw: RawProject): Project => {
  return {
    id: raw.id,
    name: raw.name,
    description: raw.description,
    startDate: raw.start_date ? new Date(raw.start_date) : null,
    endDate: raw.end_date ? new Date(raw.end_date) : null,
    deadline: raw.deadline ? new Date(raw.deadline) : null,
    isArchived: Boolean(raw.is_archived),
    owner: raw.created_by,
    funding: raw.funding,
    wbs: raw.wbs,
    learningGoal: raw.learning_goal,
  };
};
